import { buildApiV2Url } from 'src/utils/request-url';
import securedAxios from '../../../utils/secured-axios';

interface CreditCardApiResponse {
  canonical_id: string;
  tail_digits: string;
  expire_month: string;
  expire_year: string;
}

interface UserMeApiResponse {
  credit_card?: CreditCardApiResponse;
  display_name: string;
  email: string;
  firstname: string;
  id: number;
  is_email_verified: boolean;
  lastname: string;
  phone_number?: string;
  public_id: string;
}

export const fetchUsersMe = async () => {
  try {
    const res = await securedAxios.get<UserMeApiResponse>(
      buildApiV2Url(`/users/me`),
    );
    return res.status === 200 ? res.data : undefined;
  } catch (e) {
    return;
  }
};

interface SubscriptionApiResponse {
  subscription: {
    public_id: string;
  };
}

export const fetchUsersSubscription = async (productId: string) => {
  try {
    const res = await securedAxios.get<SubscriptionApiResponse>(
      buildApiV2Url(`/users/me/products/${productId}/subscription`),
    );
    return res.status === 200 ? res.data : undefined;
  } catch (e) {
    return;
  }
};
